module.exports = __webpack_public_path__ + "static/media/cve.97f97ee5.png";